module.exports = __webpack_public_path__ + "assets/img/fdbfbeff502e607e884bd8800818b3cf.png";